/*
 * @Author       : dengjianjun
 * @Date         : 2021-11-20 15:41:23
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2022-01-04 16:15:46
 * @Description  : 公共state
 * @FilePath     : /es-template/src/store/modules/common/state.js
 */
/**
 * @description: 
 * @param {*}
 * @return {*}
 */
import { mpx } from '@didi/es-mpx-creator'
export default {
  // 接口状态
  apiStatus: {},
  params: {
    member_id: '',
    company_id: '',
    city: {},
    travel_type: '',
    institution_id: '',
    landmark: '',
    checkin_date: '',
    checkout_date: '',
    train_Id: '',
    room_id: '',
    lng: '',
    lat: '',
    flow_id: ''
  },
  safeAreaTop: 0,
  xpsmInfo: {},
  locationInfo: {},
  homeApolloData: {},
  homePageData: {},
  userGroup: 1,
  requestForHomeHide: false,
  requestForMakeOrderBack: false,
  baichuanTrainPrivacy: {},
  guideTraceId: '',
  bizFrom: '',
  resetSelectSeatForRecommendBack: false,
  uniquePopupMap: {}, // 弹窗唯一标识图
};
